import Week from "../Components/Week";
import styles from "../styles/Week.module.css";
import TopBar from "../Components/TopBar";
import ApplyForm from "../Components/ApplyForm";
import Location from "../Components/Location";
import FAQs from "../Components/FAQs";
import { useState } from "react";
export default function React_Native() {
      const [openIndex, setOpenIndex] = useState(null);
    
      const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
      };
    
      const faqs = [
        {
          question: "What is React Native, and why should I learn it?",
          answer:
            <>  <span className="ans">React Native </span>is a framework for building mobile apps using JavaScript and React. It allows you
to create  <span className="ans">cross-platform apps </span>that run on both  <span className="ans">iOS & Android</span> with a single codebase. It’s
widely used by top companies like Facebook, Instagram, and Airbnb.
<p className="faq-answer fheading">
If you want to become a  <span className="ans">mobile app developer</span> without learning multiple languages like Swift
(for iOS) and Kotlin (for Android),  <span className="ans">React Native is the best choice!</span>
</p>
</>

        },
        {
            question: "Do I need prior coding experience to join the React Native course?",
            answer: (
              <>
               🔹 <span className="ans">For the 45-day bootcamp –</span>  Basic knowledge of JavaScript/React is helpful but not
  mandatory. We start with the fundamentals.
  <p className="faq-answer fheading">
  🔹  <span className="ans">For the 6-month program – </span>Some programming experience (JavaScript, HTML, CSS) is
  recommended, as we dive deeper into advanced topics like Redux, Firebase, and backend
  integration.
    </p>
  
              </>
            ),
          },
        {
          question: "What is the difference between the 45-day and 6-month course?",
          answer: <> <span className="ans">45-day bootcamp – </span>Focuses on  <span className="ans">fundamentals & rapid app development</span>. Perfect for
beginners & those who want to build apps quickly.
<p className="faq-answer fheading">
<span className="ans">6-month program –</span> Covers  <span className="ans">advanced topics, backend integration, native modules,</span>
and  <span className="ans">real-world projects</span>. Ideal for those serious about a career in mobile app development.
</p>
</>,
        },
     
    
        {
          question: "What tools and technologies will I learn?",
          answer:
           <>
           You’ll work with:
<p className="faq-answer fheading ms-2">🔹 React Native CLI & Expo</p>
<p className="faq-answer fheading ms-2">🔹 JavaScript & TypeScript</p>
<p className="faq-answer fheading ms-2">🔹 Redux & Context API</p>
<p className="faq-answer fheading ms-2">🔹 React Navigation & Deep Linking</p>
<p className="faq-answer fheading ms-2">🔹 Firebase Authentication & Firestore Database</p>
<p className="faq-answer fheading ms-2">🔹 REST APIs & GraphQL</p>
<p className="faq-answer fheading ms-2">🔹 Native Modules (Camera, GPS, Sensors, Payment Integration, etc.)</p>
<p className="faq-answer fheading ms-2">🔹 Testing & Deployment on Play Store & App Store</p>

           </>
        },
        {
          question: "Will I build a real-world project during the training?",
          answer:
            <>Yes! 🚀 Each student will  <span className="ans">build & publish</span> a real-world  <span className="ans">React Native app</span> on the Play Store/App Store. This  <span className="ans">hands-on experience</span> ensures that you graduate with a strong portfolio.</>,
        },
        {
          question: "Will I get a certificate after completing the course?",
          answer:
            <>Yes, upon successful completion, you’ll receive a  <span className="ans">DigitalMonk React Native Developer Certificate</span>, which is industry-recognized and can be added to your resume & LinkedIn.</>,
        },
        {
          question: "What career opportunities are available after learning React Native?",
          answer:
           <>
        React Native developers are in  <span className="ans"></span>high demand globally. You can work as a:
        <p className="faq-answer fheading ms-2">🔹 Mobile App Developer (React Native)</p>
        <p className="faq-answer fheading ms-2">🔹 Frontend Engineer (React)</p>
        <p className="faq-answer fheading ms-2">🔹 Full-Stack Developer (React + Node.js)</p>
        <p className="faq-answer fheading ms-2">🔹 Startup Founder / Indie Developer</p>
           </>
        },
        {
          question: "Do you provide job placement assistance?",
          answer:
           <>
    Yes! We offer:
    <p className="faq-answer fheading ms-2">🔹Resume building & interview preparation</p>
    <p className="faq-answer fheading ms-2">🔹Referrals & networking with industry professionals</p> 
           </>
        },
        {
          question: "How is CoderMonk different from other institutes?",
          answer:
           <>
         <p className="faq-answer fheading ms-2">🔹We are the  <span className="ans">only institute in Jalandhar </span>integrating  <span className="ans"></span>AI, ChatGPT,  Whisper AI, & Web 3.0
         into our React Native curriculum.</p> 
<p className="faq-answer fheading ms-2"> 🔹We focus on  <span className="ans">practical, hands-on learning</span> rather than just theory.</p>
<p className="faq-answer fheading ms-2"> 🔹 <span className="ans">Small batch sizes</span> for personalized attention.</p>
<p className="faq-answer fheading ms-2">🔹 <span className="ans">Real-world projects & industry exposure.</span></p> 
           </>
        },
        {
            question: "How can I enroll in the React Native course?",
            answer:
             <>
         <p className="faq-answer fheading ms-2">📍  <span className="ans">Visit us at:</span> 2nd Floor DigitalMonk, Near Dominos, Doaba Chownk, Jalandhar, Punjab</p>
         <p className="faq-answer fheading ms-2">📞  <span className="ans">Call/WhatsApp:</span> +916284636956</p>
         <p className="faq-answer fheading ms-2">📅  <span className="ans">Next batch starts soon – Limited seats available!</span></p>
         <p className="faq-answer fheading ms-2">🚀  <span className="ans">Transform your career with React Native at CoderMonk</span></p>
             </>
          },
      ];
    
  const syllabusData = [
    {
      description: [
        {
          text: "Phase 1: React Native Core (Month 1-2)",
          subDescription: [
            " Deep dive into React Native architecture",
            " TypeScript with React Native",
            " Advanced state management (Redux, MobX)",
            "Navigation & deep linking",
            "Optimizing performance & handling memory leaks",
          ],
        },
        {
          text: "Phase 2: Backend & Database Integration (Month 3-4)",
          subDescription: [
            "Node.js & Express for backend development",
            "REST API & GraphQL integration",
            "Firebase, MongoDB, & SQLite for mobile apps",
            "Real-time data syncing with WebSockets",
            "Authentication & security best practices",
           
          ],
        },
        {
          text: "Phase 3: Advanced Features & Native Modules (Month 5)",
          subDescription: [
            "Integrating native modules with React Native",
            "Camera, GPS, and sensor APIs",
            " Payment gateway integration (Stripe, Razorpay)",
            "AR & VR in React Native apps",
            "Testing & automation (Jest, Detox)",
           
          ],
        },
        {
          text: "Phase 4: Capstone Projects & Industry Readiness (Month 6)",
          subDescription: [
            " Building a real-world full-fledged app",
            " Play Store & App Store deployment strategies",
            "Resume building & job interview preparation",
            "Contributing to open-source projects",
           
          ],
        }, 
      ],
    },
  ];
  
  const syllabusData_one = [
    {
      description: [
        {
          text: "Week 1: Foundations of React Native",
          subDescription: [
            " Introduction to React Native & its ecosystem",
            " Setting up the development environment (Expo & React Native CLI)",
            " React Native components & JSX basics",
            "Styling in React Native (Flexbox, Styled Components)",
            " Handling user inputs & forms",
          ],
        },
        {
          text: "Week 2: State Management & Navigation",
          subDescription: [
            "Understanding React Hooks (useState, useEffect, useRef)",
            " Navigation in React Native (React Navigation)",
            "State management basics (Context API, Redux Toolkit)",
            " Fetching data from APIs (REST & GraphQL)",
            " AsyncStorage & local database handling",
          ],
        },
        {
          text: "Week 3: Advanced UI & Performance Optimization",
          subDescription: [
            "Gesture handling & animations (Reanimated, Gesture Handler)",
            "Custom components & reusable UI",
            "Performance optimization techniques (FlatList, Memoization)",
            " Handling images & media files",
            "Theming & dark mode integration",
          ],
        },
        {
          text: "Week 4: Backend Integration & Deployment",
          subDescription: [
            " Firebase authentication & Firestore database",
            " Push notifications (Expo & FCM)",
            " Deploying apps to Play Store & App Store",
            " Debugging & troubleshooting",
            "Capstone Project: Build & Publish Your First App!",
          ],
        },
       
      ],
    },
  ];
  return (
    <>
      <style jsx>{`
     
        .syllabus_heading {
          text-align: center;
          font-size: 3rem;
          margin-bottom: 2rem;
          color: #004085;
        }
  
        .card_container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          padding: 1rem;
        }
  
        .card {
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
  
        .card:hover {
          transform: translateY(-10px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
        }
  
        .card_title {
          font-size: 1.1rem;
          color: #006a4f;
          margin-bottom: 1rem;
        }
  
        .card_sublist {
          list-style-type: circle;
          padding-left: 20px;
          margin: 0;
          color: #001f3f;
          font-weight: 600;
        }
  
        .card_subitem {
          margin-bottom: 0.5rem;
        }
  
        @media (max-width: 768px) {
          .card_container {
            grid-template-columns: 1fr;
          }
        }
  
        @media (max-width: 300px) {
          .p {
            font-size: 1.1rem;
            white-space: nowrap;
          }
        }
      `}</style>
      <div className="container-xxl py-5">
  <div className="container-fluid  d-flex align-items-center justify-content-center">
    <div className="row g-5">
      <div
        className="col-lg-6 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ minHeight: 400 }}
      >
        <div className="position-relative h-100">
          <img
            className="img-fluid position-absolute w-100 h-100"
            src="https://cdn.pixabay.com/photo/2017/11/12/00/23/app-2941192_1280.jpg"
            alt=""
            style={{ objectFit: "cover" }}
          />
        </div>
      </div>
      <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
      <div className='d-flex flex-start align-items-center justify-content-start mt-2'>
          
                    <h6 className="sub_heading text-start">Syllabus</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
        <h1 className="Heading">CoderMonk’s React Native Training Program</h1>
       
        <h6 style={{color:"#c63b36"}} className="mt-3">Build Cross-Platform Mobile Apps Like a Pro!</h6>
        <p className="mb-4" style={{color:"#001f3f"}}>
        We convert your dream project into a hybrid or native applications mobile experience
        </p>
       
     
        <a className="btn  py-3 px-5 mt-2 text-white" href="#form" style={{backgroundColor:"yellowgreen"}}>
        Join Now
        </a>
      </div>
    </div>
  </div>
</div>

<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p" style={{whiteSpace:"nowrap"}}>6-Months</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
      <div className="card_container">
        {syllabusData.map((module, index) =>
          module.description.map((item, itemIndex) => (
            <div key={itemIndex} className="card bgimg">
              <h3 className="card_title">{item.text}</h3>
              <ul className="card_sublist">
                {item.subDescription.map((subItem, subIndex) => (
                  <li key={subIndex} className="card_subitem">
                    {subItem}
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
      <div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">45-Days</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>

    <div className="card_container">
        {syllabusData_one.map((module, index) =>
          module.description.map((item, itemIndex) => (
            <div key={itemIndex} className="card bgimg">
              <h6 className="card_title">{item.text}</h6>
              <ul className="card_sublist">
                {item.subDescription.map((subItem, subIndex) => (
                  <li key={subIndex} className="card_subitem">
                    {subItem}
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
      <div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">FAQs</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>



    <div className="faq-container mb-5">
     
     <div className="faq-list">
       {faqs.map((faq, index) => (
         <div key={index} className="faq-item">
           <div
             className="faq-header"
             onClick={() => toggleFAQ(index)}
            
           >
             <h2 className="faq-question  fheading">{faq.question}</h2>
             <span className="faq-icon">
               {openIndex === index ? "−" : "+"}
             </span>
           </div>
           {openIndex === index && (
             <p className="faq-answer fheading">{faq.answer}</p>
           )}
         </div>
       ))}
     </div>
   </div>







      <div class="container-xxl mt-5 py-3" >
        <div class="container">
          
<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">Contact</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
            <div className='mt-4'>
            <ApplyForm/>
            </div>
        
        </div>
    </div>
    <div className='container mt-5 mb-5'>
        <div className='row'>
            <div className='col-12'>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.4728947145964!2d75.58318561066835!3d31.345927155633603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5bde4b978ac5%3A0xe6b30ccf89446f33!2sDigitalMonk!5e0!3m2!1sen!2sin!4v1737619055819!5m2!1sen!2sin"
                style={{ border: 0, width: "100%", height: "350px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
        </div>
    </div>

    </>
  );
  
}
